import { createContext, useContext, useMemo, useReducer } from "react";
import { reducer } from "./reducer";

export const initialState = {
  calcFormData: {},
  renewalFieldsCount: 1,
  isCalcFormSubmitted: false,
  isCalcFormValidationTriggered: false,
  isMetricFormSubmitted: false,
  showGratitudeModal: false,
  isGratitudeModalSubmitted: false,
};

export const CalculatorContext = createContext({
  controller: initialState,
  dispatch: () => null,
});

export function RevenueCalculatorProvider({ children }) {
  const [controller, dispatch] = useReducer(reducer, initialState);

  const value = useMemo(
    () => ({
      controller,
      dispatch,
    }),
    [controller, dispatch]
  );

  return (
    <CalculatorContext.Provider value={value}>
      {children}
    </CalculatorContext.Provider>
  );
}

export function useCalculatorController() {
  const context = useContext(CalculatorContext);

  if (!context) {
    throw new Error(
      "useCalculatorController should be used inside the RevenueCalculatorProvider."
    );
  }

  return context;
}
